import { Controller } from 'stimulus'

export default class extends Controller {
  static values = {
    category: String,
    action: String,
    label: String
  }

  sendEvent () {
    if (this._gtagFunction()) {
      gtag('event', this.actionValue, {
        event_category: this.categoryValue,
        event_label: this.labelValue || this.categoryValue
      })
    }
  }

  handleClick () {
    this.sendEvent()
  }

  // -----------------------------------------------------------------------------------------------

  _gtagFunction () {
    return typeof gtag == 'function'
  }
}
